const Positions = ["Minister",
 "Water envoy", 
 "Presidential envoy", 
 "Ambassador",
  "Envoy of international organizations",
  "University President", 
  "Governor",
   "Deputy Minister", 
   "Advisor", 
   "Director general", 
   "Member of the Commission",
    "Focal points",
     "International academic",
      "Associate researcher",
       "Researcher", 
       "Assistant General Director", 
       "Head of the Department",
        "Director of water resources in the governorates", 
        "Member of conference committee" , 
        "Ministry staff (employee)" ];

export default Positions